import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css'; // Import global styles (including Tailwind)
import App from './App'; // Import the main application component

const container = document.getElementById('root');
const root = createRoot(container);

// Render the main App component into the root element
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
